import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch } from '../store';


const initializer = () => {
    return {
        active: false,
        paused: false,
        stepIndex: 0,
        addPipelineDialogOpen: false,
        pipelineEditorOpen: false,
        actionSteps: [1, 3, 4, 6, 7, 8, 9, 10, 12, 14, 15, 16, 17, 18, 19, 20, 21],
    }
}


const tutorialSlice = createSlice({
  name: 'tutorial',
  initialState: initializer(),
  reducers: {
    enable(state) {
        state.active = true;
    },
    disable(state) {
        state.active = false;
        state.stepIndex = 0;
    },
    setStepIndex(state, action: PayloadAction<number>) {
        state.stepIndex = action.payload;
    },
    incrementStepIndex(state) {
        state.stepIndex = state.stepIndex + 1;
    },
    togglePause(state) {
      if(state.paused === false) {
        console.log('pause')
      }
      else {
        console.log('unpause')
      }
        state.paused = !state.paused;
    },
    toggleAddPipelineDialogOpen(state) {
      console.log(state.stepIndex);
      state.addPipelineDialogOpen = !state.addPipelineDialogOpen;
    }
  },
});

const enableTut =
  () =>
  (dispatch: AppDispatch): void => {
    dispatch(tutorialSlice.actions.enable());
  };

const disableTut =
  () =>
  (dispatch: AppDispatch): void => {
    dispatch(tutorialSlice.actions.disable());
  };

const togglePauseTut = 
  () =>
    (dispatch: AppDispatch): void => {
      dispatch(tutorialSlice.actions.togglePause());
  };


const toggleAddPipelineDialogOpenf =
  () =>
  (dispatch: AppDispatch): void => {
    dispatch(tutorialSlice.actions.toggleAddPipelineDialogOpen());
  };

const setStepIndexTut = 
  (payload: number) =>
    (dispatch: AppDispatch): void => {
    dispatch(tutorialSlice.actions.setStepIndex(payload));
  };

export { enableTut, disableTut, togglePauseTut, toggleAddPipelineDialogOpenf, setStepIndexTut };
export default tutorialSlice.reducer;
